import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { colors, spacing, shadows } from '../theme/index';

function TokenGate({ children }) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const validToken = process.env.REACT_APP_ADMIN_TOKEN || 'Musavvir20';

  const isValidToken = token === validToken;

  if (!isValidToken) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: colors.background,
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          style={{
            textAlign: 'center',
            padding: spacing.xl,
            borderRadius: '12px',
            backgroundColor: '#fff',
            boxShadow: shadows.lg,
            maxWidth: '400px',
          }}
        >
          <h1 style={{ color: colors.error, marginBottom: spacing.md }}>❌ Access Denied</h1>
          <p style={{ color: colors.textSecondary, marginBottom: spacing.lg }}>
            Invalid or missing access token. Please check your link.
          </p>
          <a
            href="/"
            style={{
              color: colors.primary,
              textDecoration: 'none',
              fontWeight: '600',
            }}
          >
            ← Return to Home
          </a>
        </motion.div>
      </div>
    );
  }

  return children;
}

export default TokenGate;
